module.exports = "/_next/static/images/fintech-5df8e5e66f7a7ba9879b4fbc00387515.svg";